import React from 'react';
import { useTranslation } from "react-i18next";
import { Button } from '@progress/kendo-react-buttons';
import { Chart, ChartLegend, ChartSeries, ChartSeriesItem, ChartTitle, ChartTooltip } from '@progress/kendo-react-charts';
import 'hammerjs';

export default function SilosInformationComponents() {

    const { t } = useTranslation();

    const series = [
        { category: 'Stock', value: 80 },
        { category: t("Global_Label_Text_Ability"), value: 20 }
    ];

    const tooltipRender = (props) => {
        const { category, value } = props.point || {};
        return (
            <div>
                <strong>{t(category)}:</strong> {value}
            </div>
        );
    };
    return (
        <div>

            <div className="container-fluid mt-4">
                <div className="col-sm-12 col-md-12 col-lg-11 mx-auto">
                    <div className="card">
                        <div className="card-body bg-light py-3">
                            <h5 className="card-title m-0">{t("Global_Label_Text_General")}</h5>
                        </div>

                        <div className="row no-gutters">
                            <div className="col-md-6 card-body d-flex flex-column align-items-center">
                                <p className="mb-1">{t("Global_Label_Text_Virtual_Stock")}: <strong>500</strong></p>
                                <p className="mb-1">{t("Global_Label_Text_Expected_Daily_Amount")}: <strong>0</strong></p>
                                <p className="mb-1">{t("Global_Label_Text_Out_Stock")}:</p>
                            </div>

                            <div className="col-md-6 card-body d-flex flex-column align-items-center">
                                <p className="mb-1">{t("Global_Label_Text_Ability")}: <strong>0</strong></p>
                                <p className="mb-1">{t("Global_Label_Text_Breakup_Date")}: <strong>1</strong></p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="container-fluid mt-4">
                <div className="col-sm-12 col-md-12 col-lg-11 mx-auto">
                    <div className="card">
                        <div className="card-body bg-light py-3">
                            <h5 className="card-title m-0">{t("Global_Label_Text_Silo_Occupation")}</h5>
                        </div>

                        <div className="row g-3">

                            <div className="col-12 col-md-4 col-lg-3 mb-3 mb-md-0">
                                <div className="card m-4">
                                    <div className="card-body bg-light">
                                        {series.map((item, index) => (
                                            <div key={index} className="d-flex align-items-center gap-2 mb-1 text-start">
                                                <span className="badge bg-primary">{item.value}</span>
                                                <span>{item.category}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-md-7 col-lg-8">
                                <div className="card-body p-2 p-md-3" style={{ minHeight: '300px' }}>
                                    <Chart>
                                        <ChartTitle />
                                        <ChartLegend
                                            position="bottom"
                                            align="end"
                                            orientation="horizontal"
                                            className="mt-3"
                                        />
                                        <ChartTooltip render={tooltipRender} />
                                        <ChartSeries>
                                            <ChartSeriesItem
                                                type="pie"
                                                data={series}
                                                field="value"
                                                categoryField="category"
                                            />
                                        </ChartSeries>
                                    </Chart>
                                </div>
                            </div>

                        </div>

                        <div className="d-flex justify-content-start mb-3 m-4">
                            <Button className="action-button me-lg-11">{t("Global_Label_Text_Consolidate_Silo")}</Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}